(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let currencyScheduled = false;
  const savedCurrency = () => { try { return localStorage.getItem('T4Currency'); } catch (_) { return null; } };
  const syncCurrency = () => {
    const currency = savedCurrency() || window.T4Sconfigs?.cartCurrency || 'AED';
    document.querySelectorAll('[data-solve-currency]').forEach(select => {
      if ([...select.options].some(option => option.value === currency)) select.value = currency;
    });
  };
  const selectCurrency = select => {
    const bridge = document.querySelector(`.solve-language-bar [data-currency-item][data-currency="${select.value}"]`) || select.parentElement.querySelector(`[data-currency-item][data-currency="${select.value}"]`);
    if (!bridge || !window.jQuery_T4NT || !window.Currency || !window.T4SThemeSP?.CurrencyT4s) {
      syncCurrency(); return;
    }
    // Use Kalles' existing money formatter, conversion rates and cart update lifecycle.
    window.jQuery_T4NT(bridge).trigger('click');
    syncCurrency();
  };
  const bindCurrency = root => {
    root.querySelectorAll('[data-solve-currency]').forEach(select => {
      if (select.dataset.sfBound) return;
      select.dataset.sfBound = '1';
      select.addEventListener('change', () => selectCurrency(select));
    });
    syncCurrency();
  };
  const init = () => {
    bindCurrency(document);
    document.querySelector('.solve-future-object')?.classList.add('solve-enter-graphic');
    document.querySelectorAll('.solve-page-heading,.solve-collection-directory,.solve-lens-guide').forEach(section => section.classList.add('solve-future-ready'));
    // Lazy cart/menu HTML arrives after the initial document; only initialize when needed.
    const observer = new MutationObserver(records => {
      let controlsAdded = false;
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1 && (node.matches?.('[data-solve-currency]') || node.querySelector?.('[data-solve-currency]'))) controlsAdded = true;
      }));
      if (controlsAdded && !currencyScheduled) {
        currencyScheduled = true;
        requestAnimationFrame(() => { currencyScheduled = false; bindCurrency(document); });
      }
    });
    observer.observe(document.body, {childList:true,subtree:true});
    if (window.jQuery_T4NT) {
      window.jQuery_T4NT('body').on('currency:update.sf', syncCurrency);
      window.jQuery_T4NT(document).on('lazyincluded.sf', syncCurrency);
    }
    window.addEventListener('storage', event => { if (event.key === 'T4Currency') syncCurrency(); });
    // Pause ambient orbit animation when the graphic is outside the viewport.
    if ('IntersectionObserver' in window) {
      const animationObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        entry.target.querySelectorAll('.solve-orbit-spin,.solve-orbit-tilt').forEach(el => {
          el.style.animationPlayState = entry.isIntersecting && !reduced.matches ? 'running' : 'paused';
        });
      }));
      document.querySelectorAll('.solve-orbit-art').forEach(el => animationObserver.observe(el));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', event => bindCurrency(event.target));
})();
